export default {
    type: 'panel',
    name: 'default',
    blocks: [
        {
            name: 'content', // name or id; MUST be unique
            label: 'Content', // Display name, if not set, name is used
            max: 1, // max same items allowed
            type: 'html', // || text || link || image || mixed (with children)
            // items: [{text: '<p>azerty 123456</p>'}], // values saved inserted in content model
        },
    ],
};
